import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { READER_ENV, READER_MESSAGE_EVENT_PREFIX, READER_MESSAGE_EVENTS_TO_RECEIVE, READER_MESSAGE_EVENTS_TO_SEND } from "../config/constants";
import { ModalCompartir } from "../components/modals/modal-compartir";
import { useBookData } from "../fichas/useBookData";
import MicroModal from "micromodal";
import { useNetworkStatus } from "../hooks/use-network-status";
import { ReaderMessageService } from "./services/reader-message-service";
import { useLanguage } from "../hooks/use-language";

export const Reader = () => {
	const lang = useLanguage();
	const params = useParams();
	const bookId = params?.idLibro;
	const book = useBookData(bookId);
	const networkStatus = useNetworkStatus();
	const memoIsOnline = useMemo(() => networkStatus.online, [networkStatus.online]);

	const readerSrc = `/makemake-reader/index.html
	?bookId=${bookId}
	&lang=${lang}
	&platform=classics
	&env=${READER_ENV}
	&appToken=null
	&downloaded_in_app=false
	`;

	useEffect(() => {
		window.addEventListener("message", handleReaderEvents);
		return () => {
			window.removeEventListener("message", handleReaderEvents);
		};
	}, [bookId]);

	const handleReaderEvents = (event) => {
		handleActivityClickEvent(event);
		handleShareClickEvent(event);
		handleRecommendLinksClickEvent(event);
	};

	const handleActivityClickEvent = (e) => {
		const data = e.data;
		const eventId = data?.eventId;
		if (eventId === `${READER_MESSAGE_EVENT_PREFIX}${READER_MESSAGE_EVENTS_TO_RECEIVE.ACTIVITY_CLICK}`) {
			const url = data?.payload?.activityUrl;
			window.open(url, "_blank");
		}
	};
	const handleRecommendLinksClickEvent = (e) => {
		const data = e.data;
		const eventId = data?.eventId;
		if (eventId === `${READER_MESSAGE_EVENT_PREFIX}${READER_MESSAGE_EVENTS_TO_RECEIVE.RECOMMENDED_LINK_CLICK}`) {
			const url = data?.payload?.url;
			window.open(url, "_blank");
		}
	};

	const handleShareClickEvent = (e) => {
		const data = e.data;
		const eventId = data?.eventId;
		if (eventId === `${READER_MESSAGE_EVENT_PREFIX}${READER_MESSAGE_EVENTS_TO_RECEIVE.SHARE_CLICK}`) {
			openShareModal();
		}
	};

	const openShareModal = () => {
		MicroModal.show("modal-compartir-visor", {
		  awaitCloseAnimation: true,
		});
	  };

	useEffect(()=>{
		const interval = setInterval(() => {
			ReaderMessageService.sendMessage({eventId:READER_MESSAGE_EVENTS_TO_SEND.NETWORK_STATUS_CHANGES, payload:{isOnline:memoIsOnline}})
		}, 3000);
		return ()=>{
			clearInterval(interval);
		}
	},[memoIsOnline])

	return (
		<>
			<div className="reader-container">
				<iframe
					title="Reader"
					key={bookId}
					className="w-100 h-100"
					src={readerSrc}
					style={{ border: "none", outline: "none" }}
				></iframe>
			</div>
		     <ModalCompartir idModal={"modal-compartir-visor"} libro={book.metadata} />
		</>
	);
};
